import * as TP from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserReferenceTypesQueryVariables = TP.Exact<{ [key: string]: never; }>;


export type GetUserReferenceTypesQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getUserReferenceTypes: ReadonlyArray<(
    { readonly __typename?: 'UserReferenceTypeResponse' }
    & Pick<TP.UserReferenceTypeResponse, 'modalId' | 'updatedAt'>
    & { readonly referenceTypes: ReadonlyArray<(
      { readonly __typename?: 'ReferenceTypeObject' }
      & Pick<TP.ReferenceTypeObject, 'id' | 'label' | 'referenceType'>
    )> }
  )> }
);


export const GetUserReferenceTypesDocument = gql`
    query GetUserReferenceTypes {
  getUserReferenceTypes {
    modalId
    updatedAt
    referenceTypes {
      id
      label
      referenceType
    }
  }
}
    `;

/**
 * __useGetUserReferenceTypesQuery__
 *
 * To run a query within a React component, call `useGetUserReferenceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserReferenceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserReferenceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserReferenceTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserReferenceTypesQuery, GetUserReferenceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserReferenceTypesQuery, GetUserReferenceTypesQueryVariables>(GetUserReferenceTypesDocument, options);
      }
export function useGetUserReferenceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserReferenceTypesQuery, GetUserReferenceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserReferenceTypesQuery, GetUserReferenceTypesQueryVariables>(GetUserReferenceTypesDocument, options);
        }
export type GetUserReferenceTypesQueryHookResult = ReturnType<typeof useGetUserReferenceTypesQuery>;
export type GetUserReferenceTypesLazyQueryHookResult = ReturnType<typeof useGetUserReferenceTypesLazyQuery>;
export type GetUserReferenceTypesQueryResult = Apollo.QueryResult<GetUserReferenceTypesQuery, GetUserReferenceTypesQueryVariables>;
/** Cypress helper for mocking the GetUserReferenceTypes query */
export const mockGetUserReferenceTypes = (
  response: MockResponse<GetUserReferenceTypesQuery>,
  kwargs?: Cypress.GqlKwargs
): void => cy.gql<GetUserReferenceTypesQuery>('GetUserReferenceTypes', response as anyOk, kwargs);